export function titleElement(title) {
  return `
    <h2 class="vjs-next-video-service__title">
      ${title}
    </h2>`
}

export function descriptionElement(description) {
  return `
    <p class="vjs-next-video-service__description">
      ${description}
    </p>`
}

export function countdownElement(text) {
    return `<p class='vjs-next-video-service__countdown'>
      ${text}
    </p>`
}

export function thumbnailElement(link, image_url) {
    return `
      <a class="vjs-next-video-service__thumbnail" href="${link}" target="_parent" style='background-image:url("${image_url}");'>
        <div class="vjs-next-video-service__thumbnail-oval">
          <div class="vjs-next-video-service__thumbnail-play"></div>
        </div>
        <div class="vjs-next-video-service__thumbnail-overlay"></div>
      </a>
    `;
}
